import "@/assets/css/styles.scss";

// VueJS
import Vue from "vue";
import App from "~/App.vue";

// Configuration
import router from "@/config/router";
import store from "@/config/store";
import i18n from "@/config/i18n";

Vue.config.productionTip = false;

// Plugins
import VueRouter from 'vue-router';
import VueCookies from 'vue-cookies-reactive';
import VueI18n from 'vue-i18n';

Vue.use(VueRouter);
Vue.use(VueCookies);
Vue.use(VueI18n);

// Layouts
import Blank from "@/layouts/Blank.vue";
import DefaultCoreLayout from "@/layouts/Default.vue";
import Checkout from "@/layouts/Checkout.vue";

Vue.component('default-layout', DefaultCoreLayout);
Vue.component("blank-layout", Blank);
Vue.component("checkout-layout", Checkout);

// Utils
import "@/utils/filters";
import icons from "@/utils/icons";

Vue.prototype.$icons = icons;

// API
import Api from "@/api/Api";
import { SedMosaiqRelayProvider } from "@/api/services/relay-providers/SedMosaiqRelayProvider";

Api.relay.registerRelayProvider(new SedMosaiqRelayProvider());

new Vue(
    {
        router,
        store,
        i18n,
        render: h => h(App),
    },
).$mount("#app");
